import 'css-chunksrc/client/pages/planzoneMembersPage/resource/pendingStatus/styles.scss';export default {
  "pendingStatus": "_pendingStatus_1x6za_1"
};